import React from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";
import axios from "axios";
import ArrayUtil from "../../util/ArrayUtil";
import APIUrl from "../../APIUrl";
import { transferEquipment } from "../../actions/equipments/equipments";

class EquipmentTransferModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedEstablishmentOption: null,
      establishment_id: "",
      activeRental: null,
      loadingRental: true,
      showConfirmModal: false,
    };
  }

  componentDidMount() {
    this.checkActiveRental();
  }

  checkActiveRental() {
    // Vérifier si l'équipement a une location active
    axios
      .get(`${APIUrl.rootUrl}/equipment/${this.props.equipment._id}/active-rental`)
      .then((response) => {
        this.setState({
          activeRental: response.data.activeRental,
          loadingRental: false,
        });
      })
      .catch((err) => {
        console.error("Error checking active rental:", err);
        this.setState({ loadingRental: false });
      });
  }

  getEstablishmentsSelectOptions() {
    const options = [];

    // Option pour désassigner l'équipement
    options.push({
      value: "unassigned",
      label: "Équipement non assigné",
      isSpecial: true,
    });

    // Liste de tous les établissements sauf celui actuel
    const establishments = this.props.establishments
      .filter((e) => e._id !== this.props.currentEstablishmentId)
      .sort((a, b) => ArrayUtil.ascendingSort(a.name, b.name));

    for (const establishment of establishments) {
      options.push({
        value: establishment._id,
        label: establishment.name,
        isSpecial: false,
      });
    }

    return options;
  }

  handleTransferClick() {
    if (!this.state.selectedEstablishmentOption) return;

    // Si l'équipement a une location active, afficher la modal de confirmation
    if (this.state.activeRental) {
      this.setState({ showConfirmModal: true });
    } else {
      this.executeTransfer();
    }
  }

  executeTransfer() {
    const targetEstablishmentId =
      this.state.selectedEstablishmentOption.value === "unassigned"
        ? null
        : this.state.selectedEstablishmentOption.value;

    const data = {
      equipmentId: this.props.equipment._id,
      fromEstablishmentId: this.props.currentEstablishmentId,
      toEstablishmentId: targetEstablishmentId,
      terminateActiveRental: true, // Indiquer au backend de terminer la location active
    };

    this.props.onTransferEquipment(data, () => {
      this.props.close();
    });
  }

  closeConfirmModal() {
    this.setState({ showConfirmModal: false });
  }

  render() {
    const { activeRental, loadingRental, showConfirmModal } = this.state;

    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.data.isSpecial
          ? state.isFocused
            ? "#ffc107"
            : "#fff3cd"
          : state.isFocused
          ? "#e9ecef"
          : "white",
        color: state.data.isSpecial ? "#856404" : "#000",
        fontWeight: state.data.isSpecial ? "bold" : "normal",
      }),
    };

    // Modal de confirmation si location active
    if (showConfirmModal) {
      return (
        <Modal show={true} onHide={() => this.closeConfirmModal()} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Confirmer le transfert</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="alert alert-warning" role="alert">
              <i className="fas fa-exclamation-triangle mr-2"></i>
              <strong>Attention :</strong> Cet équipement a une location en cours
              {activeRental?.establishment?.name && (
                <span> chez <strong>{activeRental.establishment.name}</strong></span>
              )}.
            </div>
            <p>
              Si vous confirmez le transfert, la location en cours sera automatiquement
              <strong> terminée</strong> avec la date de fin à aujourd'hui.
            </p>
            <p>Voulez-vous continuer ?</p>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.closeConfirmModal()}>
              Annuler
            </Button>
            <Button
              variant="danger"
              onClick={() => this.executeTransfer()}
            >
              Confirmer le transfert
            </Button>
          </Modal.Footer>
        </Modal>
      );
    }

    return (
      <Modal show={true} onHide={() => this.props.close()} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Transférer un équipement</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-3">
            <p>
              <strong>Équipement à transférer :</strong>
            </p>
            <p className="text-muted">
              {this.props.equipment.internal_ref} -{" "}
              {this.props.getBrandName(this.props.equipment.brand_id)}{" "}
              {this.props.getModelName(this.props.equipment.model_id)}
            </p>
          </div>

          {/* Avertissement si location active */}
          {loadingRental && (
            <div className="text-center my-3">
              <i className="fas fa-spinner fa-spin"></i> Vérification des locations...
            </div>
          )}

          {!loadingRental && activeRental && (
            <div className="alert alert-danger" role="alert">
              <i className="fas fa-exclamation-circle mr-2"></i>
              <strong>Location en cours :</strong> Cet équipement est actuellement en location
              {activeRental.establishment?.name && (
                <span> chez <strong>{activeRental.establishment.name}</strong></span>
              )}.
              <br />
              <small className="text-muted">
                Si vous transférez cet équipement, la location sera automatiquement terminée.
              </small>
            </div>
          )}

          <div className="form-group">
            <label htmlFor="transfer-establishment">
              <strong>Destination :</strong>
            </label>
            <Select
              id="transfer-establishment"
              placeholder="Sélectionner un client ou désassigner..."
              noOptionsMessage={() => "Aucun résultat"}
              onChange={(option) => {
                this.setState({
                  selectedEstablishmentOption: option,
                  establishment_id: option.value,
                });
              }}
              value={this.state.selectedEstablishmentOption}
              options={this.getEstablishmentsSelectOptions()}
              styles={customStyles}
            />
          </div>

          {this.state.selectedEstablishmentOption?.isSpecial && (
            <div className="alert alert-warning mt-3" role="alert">
              <strong>Attention :</strong> L'équipement sera retiré du client
              actuel et placé dans la section "Équipements non assignés".
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => this.props.close()}>
            Annuler
          </Button>
          <Button
            variant="primary"
            onClick={() => this.handleTransferClick()}
            disabled={!this.state.selectedEstablishmentOption || loadingRental}
          >
            Transférer
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    establishments: state.establishments,
    brands: state.brands,
    models: state.models,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onTransferEquipment: (data, successCallback) =>
      dispatch(transferEquipment(data, successCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(EquipmentTransferModal));
